import { workspaceDeveloperQueryKeys as e } from "./useWorkspaceDeveloperQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { workspaceDeveloperApi as n } from "@maat/api-main";
//#region src/workspaceDeveloper/useWorkspaceDeveloperQuery.ts
var r = (r = !0) => t({
	queryKey: e.status(),
	queryFn: () => n.status(),
	enabled: r
});
//#endregion
export { r as useWorkspaceDeveloperQuery };
